import React, { useEffect } from 'react';

import { List, Menu, MenuItem, MenuProps, PopoverProps } from '@material-ui/core';
import { MoreVert } from '@material-ui/icons';

// add more as needed
type AnchorDirection = 'bottom-left' | 'bottom-center' | 'bottom-right';

type Props = {
  anchor?: AnchorDirection;
  className?: string;
  disabled?: boolean;
  id: string;
  menuClasses?: string;
  onBlur?: () => void;
  onFocus?: () => void;
  popoverClasses?: PopoverProps['classes'];
  renderButton?: () => JSX.Element;

  // This return type is enforced by a material UI error message (it must be a List or an array of MenuItem, and not a fragment)
  children: (closeMenu: () => void) => React.ReactElement<typeof MenuItem | typeof List>[];
}
export default function ActionMenu ({
  anchor = 'bottom-left',
  children,
  className,
  disabled,
  id,
  menuClasses,
  onBlur,
  onFocus,
  popoverClasses,
  renderButton,
}: Props) {
  const [menuAnchor, setMenuAnchor] = React.useState<null | HTMLElement>(null);

  useEffect(() => {
    menuAnchor ? onFocus?.() : onBlur?.();
  }, [menuAnchor]);

  return (
    <>
      <button
        className={className}
        aria-controls={id}
        aria-haspopup="true"
        disabled={disabled}
        onClick={(event) => setMenuAnchor(event.currentTarget)}
        onFocus={onFocus}
        onBlur={onBlur}
        onMouseEnter={onFocus}
        onMouseLeave={menuAnchor === null ? onBlur : undefined}
      >
        {renderButton ? renderButton() : <MoreVert />}
      </button>
      <Menu
        className={menuClasses}
        PopoverClasses={popoverClasses}
        id={id}
        anchorEl={menuAnchor}
        keepMounted
        open={Boolean(menuAnchor)}
        onClose={() => setMenuAnchor(null)}
        elevation={0}
        getContentAnchorEl={null}
        {...anchorProps[anchor]}
      >
        {children(() => setMenuAnchor(null))}
      </Menu>
    </>
  );
}

const anchorProps: { [key in AnchorDirection]: Partial<MenuProps>} = {
  'bottom-left': {
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'right',
    },
    transformOrigin: {
      vertical: 'top',
      horizontal: 'right',
    },
  },
  'bottom-center': {
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'center',
    },
    transformOrigin: {
      vertical: 'top',
      horizontal: 'center',
    },
  },
  'bottom-right': {
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'left',
    },
    transformOrigin: {
      vertical: 'top',
      horizontal: 'left',
    },
  },
};
